import { Single as SingleRecipient } from './Single';

export default SingleRecipient;
